export const cloneConfigModal = {
  close: "Schließen",
  searchPlaceholder: "Inserat suchen…",
  clearSearch: "Leeren",
  bar: {
    chooseSource: "Quell-Inserat auswählen",
    selected: "{count} ausgewählt | {count} ausgewählt",
    selectAll: "Alle auswählen",
    clear: "Leeren",
  },
  list: {
    loading: "Inserate werden geladen…",
    empty: "Keine Inserate passen zu Ihrer Suche.",
    unitsBadge: "{count} Einheiten",
  },
  confirm: {
    sourceLabel: "Gewählte Quelle",
    applyToLabel: "Wird angewendet auf",
    andItsUnits: "(und seine {count} Einheiten)",
    andMore: "und {count} weitere",
    undoWarning: "Diese Aktion kann nicht rückgängig gemacht werden.",
  },
  footer: {
    back: "Zurück",
    cancel: "Abbrechen",
    continue: "Weiter",
  },
  preview: {
    unit: "Einheit",
    listing: "Inserat",
    empty: "Nicht eingerichtet.",
    loading: "Wird geladen…",
  },
  confirmTitle: {
    pull: "Vor dem Übernehmen bestätigen",
    push: "Vor dem Kopieren prüfen",
  },
  confirmLabel: {
    pulling: "Wird übernommen…",
    copying: "Wird kopiert…",
    confirmPull: "Ja, Einstellungen übernehmen",
    confirmPush: "Ja, in {count} Inserat kopieren | Ja, in {count} Inserate kopieren",
  },
  intro: {
    pullLead: "Sie sind dabei, {noun} aus dem gewählten Inserat zu übernehmen.",
    pullReplace: "Damit wird ersetzt, was Sie hier derzeit haben.",
    pullAdd: "Es wird zu dem hinzugefügt, was Sie hier bereits haben.",
    pushLead: "Sie sind dabei, {noun} in {count} Inserat zu kopieren. | Sie sind dabei, {noun} in {count} Inserate zu kopieren.",
    pushReplace: "Damit wird ersetzt, was dieses Inserat derzeit hat{scope}. | Damit wird ersetzt, was diese Inserate derzeit haben{scope}.",
    pushAdd: "Es wird zu dem hinzugefügt, was dieses Inserat bereits hat. | Es wird zu dem hinzugefügt, was diese Inserate bereits haben.",
    pushScope: ", einschließlich der Versandeinstellungen",
  },
  attachments: {
    fileFallback: "Anhang",
    titleAlsoCopied: "Anhänge werden ebenfalls kopiert",
    titlePullLose: "Sie verlieren die Anhänge, die Sie derzeit haben",
    titlePullGain: "Seine Anhänge werden ebenfalls übernommen",
    titlePushEmpty: "Die gewählten Inserate bleiben ohne Anhänge zurück",
    noteUnknownPull: "Die Anhänge des gewählten Inserats ersetzen die hier vorhandenen, die gelöscht werden.",
    noteUnknownPush: "Die Anhänge dieses Inserats ersetzen die der gewählten Inserate, die gelöscht werden.",
    notePullReplace: "Sie werden gelöscht und durch die des gewählten Inserats ersetzt.",
    notePullEmpty: "Hier gibt es derzeit keine Anhänge, Sie verlieren also nichts: Die des gewählten Inserats werden übernommen.",
    notePushEmpty: "Dieses Inserat hat keine Anhänge, daher werden die des gewählten Inserats gelöscht und es bleibt ohne Anhänge zurück. | Dieses Inserat hat keine Anhänge, daher werden die der gewählten Inserate gelöscht und sie bleiben ohne Anhänge zurück.",
    notePushReplace: "Sie werden in das gewählte Inserat kopiert und ersetzen dessen eigene, die gelöscht werden. | Sie werden in die gewählten Inserate kopiert und ersetzen deren eigene, die gelöscht werden.",
  },
  toast: {
    loadError: "Die Inserate konnten nicht geladen werden",
    pullSuccess: "Einstellungen erfolgreich übernommen",
    pushSuccess: "Einstellungen in {count} Inserat kopiert | Einstellungen in {count} Inserate kopiert",
    pullError: "Die Einstellungen konnten nicht übernommen werden",
    pushError: "Die Einstellungen konnten nicht kopiert werden",
  },
};
